export default __webpack_public_path__ + "static/media/KOD0152-min.67f66ca7.webp";